import styled from "styled-components";

export const NavLinks = styled.div`
  padding-bottom: 25px;

  a {
    margin-right: 10px;
    color: white;
    text-decoration: none;
  }
`;
